import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParMajor from './par-major';
import ParMajorDetail from './par-major-detail';
import ParMajorUpdate from './par-major-update';
import ParMajorDeleteDialog from './par-major-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParMajorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParMajorUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParMajorDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParMajor} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParMajorDeleteDialog} />
  </>
);

export default Routes;
